import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useLogin } from "../../../../context/LoginContext";

import { useTawk } from "../../../../context/TawkContext";
import localStorageKey from "../../../../enumerations/localStorageKey";
import { useGetTGLink } from "../../../../hooks/tgLink/tglink.hooks";
import { envChangeType, envType } from "../../../../plugins/utils";
import { clickToScroll } from "../../utils";
import CSPopup from "../CSPopup";
import CustomBubble from "./components/CustomBubble";
import "./style.scss";

const DEFAULT_CURRENCY = localStorage.getItem(localStorageKey.DEFAULT_CURRENCY);

function BonusWheelBubble({
  isFloatingBubble = true,
  closeIconColor = "var(--color-bonusWheel-bubble-close)",
  initialBottomPosition = 76,
  setIsShowing = () => {},
  showTopCloseIcon = false,
  showCsCloseIcon = true,
  positionBottom = 206,
  showTopBubble = false,
  isBigCsSize = true,
  customIconStyle,
  containerId = "gameContainer",
}) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { checkIfLogin, isLogin } = useLogin();
  const { tawkLoaded, openTawkChat } = useTawk();
  const currency = localStorage.getItem(localStorageKey.DEFAULT_CURRENCY);

  const [showTelegramBubble, setShowTelegramBubble] = useState(true);
  const [showCsBubble, setShowCsBubble] = useState(true);
  const [showTop, setShowTop] = useState(false);
  const [visible, setVisible] = useState(false);

  // const { data: apiShowBubble } = useCheckShowBubble({
  //   enabled: envChangeType("REACT_APP_DEFAULT_CURRENCY") !== "" && isLogin,
  //   staleTime: 60 * (60 * 1000), //60mins
  //   cacheTime: 60 * (60 * 1000), //60mins
  // });

  const { data: tgLink } = useGetTGLink({
    options: { enabled: !!currency && envChangeType("REACT_APP_SHOW_TG_BUBBLE", envType.BOOLEAN) },
  });

  const scrollProcess = () => {
    const scrollContainer = document.getElementById(containerId);
    if (scrollContainer?.scrollTop >= 100) {
      setShowTop(true);
    } else {
      setShowTop(false);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", scrollProcess, true);
    return () => {
      window.removeEventListener("scroll", scrollProcess, true);
    };
  }, []);

  const onClickCSBubble = () => {
    if (envChangeType("REACT_APP_TAWK_PROPERTY_ID") && envChangeType("REACT_APP_TAWK_WIDGET_ID")) {
      if (tawkLoaded) {
        openTawkChat();
      }
      return;
    }
    setVisible(true);
  };

  return (
    <>
      {showTopBubble && showTop && (
        <CustomBubble
          // apiShowBubble={apiShowBubble}
          initialBottomPosition={initialBottomPosition + (isBigCsSize ? 80 : 54) + 54}
          closeIconColor={closeIconColor}
          icon={`/images/logo/${envChangeType("REACT_APP_PRODUCTION_NAME_DEV")}/top_icon.png`}
          onClick={() => clickToScroll(containerId, 0)}
          setShowBubble={setShowTop}
          showCloseIcon={showTopCloseIcon}
          positionBottom={positionBottom + (isBigCsSize ? 80 : 54) + 54}
          customIconStyle={customIconStyle}
        />
      )}
      {envChangeType("REACT_APP_SHOW_TG_BUBBLE", envType.BOOLEAN) &&
        tgLink?.data &&
        showTelegramBubble && (
          <CustomBubble
            // apiShowBubble={apiShowBubble}
            initialBottomPosition={initialBottomPosition + (isBigCsSize ? 80 : 54)}
            closeIconColor={closeIconColor}
            icon={`/images/logo/${envChangeType("REACT_APP_PRODUCTION_NAME_DEV")}/tg_icon.png`}
            onClick={() => window.open(tgLink?.data)}
            setShowBubble={setShowTelegramBubble}
            positionBottom={positionBottom + (isBigCsSize ? 80 : 54)}
          />
        )}
      {envChangeType("REACT_APP_SHOW_CS_BUBBLE", envType.BOOLEAN) && showCsBubble && (
        <CustomBubble
          // apiShowBubble={apiShowBubble}
          initialBottomPosition={initialBottomPosition}
          closeIconColor={closeIconColor}
          icon={`/images/logo/${envChangeType("REACT_APP_PRODUCTION_NAME_DEV")}/cs_icon.png`}
          onClick={onClickCSBubble}
          setShowBubble={setShowCsBubble}
          showCloseIcon={showCsCloseIcon}
          positionBottom={positionBottom}
          closeIconStyle={isBigCsSize ? { fontSize: 24 } : { fontSize: 20 }}
        />
      )}
      <CSPopup
        visible={visible}
        onClose={() => {
          setVisible(false);
        }}
      />
    </>
  );
}

export default BonusWheelBubble;
